<template>
  <div class="modular">
    <div class="radiobox">
      <div class="radio">
        <el-radio v-model="radio" :label="1">饼状图</el-radio>
        <!-- <el-radio v-model="radio" :label="2">圆形图</el-radio> -->
      </div>
    </div>
    <div v-show="radio === 1" v-loading="chartLoading">
      <div class="timesheet" style="padding:20px">
        <div class="block">
          <el-date-picker
            v-model="value2"
            type="datetimerange"
            align="right"
            format="yyyy-MM-dd hh:mm:ss"
            value-format="yyyy-MM-dd hh:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" @click="clickBtn()">查询</el-button>
        </div>
      </div>
      <div ref="modularChild2i" class="echarts"></div>
    </div>
    <div v-show="radio === 2" v-loading="chartLoading">
      <div ref="modularChild2ii" class="echarts"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import * as echarts from "echarts"
export default {
  name: 'modularChild2',
  props: ['socUserName'],
  data() {
    return {
      value1: '',
      value2: [],      
      radio: 1,
      chartLoading: false,
      optioni: {
        title: {
          // text: "南丁格尔玫瑰图",
          // subtext: "纯属虚构",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          left: "center",
          top: "top",
          // data: [
          //   "DNS",
          //   "HTTP",
          //   "DCE/RPC",
          //   "FTP",
          //   "Telnet",
          // ]
        },
        toolbox: {
          show: false,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: {
              show: true,
              type: ["pie", "funnel"]
            },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        series: [
          {
            name: "通讯协议流量和类型统计",
            type: "pie",
            radius: [20, 110],
            center: ["25%", "50%"],
            roseType: "radius",
            label: {
              show: false
            },
            emphasis: {
              label: {
                show: true
              }
            },
            data: [
              // {value: 10.1, name: 'DNS'},
              // {value: 14.4, name: 'HTTP'},
              // {value: 3.6, name: 'DCE/RPC'},
              // {value: 8.4, name: 'FTP'},
              // {value: 30.5, name: 'Telnet'},
            ]
          },
          {
            name: "通讯协议流量和类型统计",
            type: "pie",
            radius: [30, 110],
            center: ["75%", "50%"],
            roseType: "area",
            data: [
              // {value: 10.1, name: 'DNS'},
              // {value: 14.4, name: 'HTTP'},
              // {value: 3.6, name: 'DCE/RPC'},
              // {value: 8.4, name: 'FTP'},
              // {value: 30.5, name: 'Telnet'},
            ]
          }
        ]
      },
      optionii: {
        title: {
          text: "Les Miserables",
          subtext: "Circular layout",
          top: "bottom",
          left: "right"
        },
        tooltip: {},
        legend: [
          {
            // data: categories.map(function(a) {
            //   return a.name;
            // })
          }
        ],
        animationDurationUpdate: 1500,
        animationEasingUpdate: "quinticInOut",
        series: [
          {
            name: "Les Miserables",
            type: "graph",
            layout: "circular",
            circular: {
              rotateLabel: true
            },
            data: [],
            links: [],
            categories: [],
            roam: true,
            label: {
              position: "right",
              formatter: "{b}"
            },
            lineStyle: {
              color: "source",
              curveness: 0.3
            }
          }
        ]
      },
    endTime: "",
    username: "",
    startTime: ""
    };
  },
  methods: {
    getTime(socUserName){
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true;      
      var nowdate = new Date();
      var startTime = nowdate.setMonth(nowdate.getMonth()-1); 
      var endTime = Date.parse(new Date());
      let params = {
        "endTime": endTime,
        "username": socUserName,
        "startTime": startTime
      }
      this.getData(params)
    },
    clickBtn(socUserName) {     
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true; 
      let params = {
        'endTime': this.value2 ? Date.parse(this.value2[1]) : '',
        'username': socUserName,
        'startTime': this.value2 ? Date.parse(this.value2[0]) : ''
      }     
      this.getData(params)
    },
    getData(params) {
      this.$http.post(`/front/consumer/order/soc/interface/queryTrafficAndTypeStatistics`, params)
        .then(data => {
          if (data && data.status === 200 && data.data.code === 0) {  
            let res = this.formatterData(data.data.data)
            this.chartsi.setOption(res.optioni)
            this.chartsii.setOption(res.optionii)
          } else {
            this.$message.error(data.result.msg)
          }
          this.chartLoading = false
        })
        .catch(() => {
          this.chartLoading = false
        })
      // // 假数据
      // let res = this.formatterData()
      // this.chartsi.setOption(this.optioni)
      // this.chartsii.setOption(this.optionii)
      // this.chartLoading = false
      // // 假数据
    },
    formatterData(data) {
      this.optioni.series[0].data = this.optioni.series[1].data = data      
      return {
        optioni: this.optioni,
        optionii: this.optionii
      }
    }
  },
  mounted() {
    let charti = echarts.getInstanceByDom(this.$refs["modularChild2i"]);
    if (charti === undefined) {
      this.chartsi = echarts.init(this.$refs["modularChild2i"]);
      this.$once("hook:beforeDestroy", function() {
        echarts.dispose(this.chartsi);
      });
    }
    let chartii = echarts.getInstanceByDom(this.$refs["modularChild2ii"]);
    if (chartii === undefined) {
      this.chartsii = echarts.init(this.$refs["modularChild2ii"]);
      this.$once("hook:beforeDestroy", function() {
        echarts.dispose(this.chartsii);
      });
    }
    this.getTime();
  }
};
</script>

<style lang="scss" scoped>
.modular {
  position: relative;
  .radiobox {
    pointer-events: none;
    width: 100%;
    position: absolute;
    top: -30px;
    .radio {
      pointer-events: auto;
      width: 100px;
      margin: 0 auto;
    }
  }
  .echarts {
    height: calc(100vh - 370px);
  }
}
</style>